/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ScheduleTaskChangeDateAfterCompleteType, ScheduleTaskType, ScheduleType } from '@gh/builder-shared-data';

import {
  AbstractSnapshotFormComponent,
  EnumDictionary,
  FormState,
  FormStateBuilder,
  FormStateSnapshot,
  LocalizationBusinessService,
  NumberTypes,
  whenCreateOrEditMode,
} from '@gh/common-shared';

import { includes } from 'lodash';

import { ScheduleTemplateTaskInfo } from '../../../resources/scheduling-schedule-template-task.model';

@Component({
  selector: 'gh-scheduling-schedule-template-task-details-top-form',
  template: require('./scheduling-schedule-template-task-details-top-form.component.html'),
  styles: [require('./scheduling-schedule-template-task-details-top-form.component.scss')],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SchedulingScheduleTemplateTaskDetailsTopFormComponent extends AbstractSnapshotFormComponent<ScheduleTemplateTaskInfo>
  implements OnInit {

  @Input() changeDateAfterCompleteTypes: EnumDictionary<ScheduleTaskChangeDateAfterCompleteType>;
  @Input() scheduleTaskTypes: EnumDictionary<ScheduleTaskType>;
  @Input() type: ScheduleTaskType;
  @Input() templateType: ScheduleType;
  @Input() fromCriticalPath: boolean;
  @Output() clearResource = new EventEmitter<any>();

  constructor(private formStateBuilder: FormStateBuilder,
              private localizationBusinessService: LocalizationBusinessService) {
    super();
  }

  get isCostCenterCodeControlExists(): boolean {
    return this.type === ScheduleTaskType.CostCenter;
  }

  get isChangeDateAfterCompleteControlExists(): boolean {
    return this.templateType === ScheduleType.PreConstruction;
  }

  get isVisibleClear(): boolean {
    return !!this.state.value.resource;
  }

  formattedDurationControlValue(): string {
    return this.state.value.duration
      && this.localizationBusinessService.formatHoursDuration(this.state.value.duration)
      || '';
  }

  onClear(): void {
    this.clearResource.emit(this.state.value);
  }

  protected buildForm(snapshot: FormStateSnapshot<ScheduleTemplateTaskInfo>): FormState<ScheduleTemplateTaskInfo> {
    return this.formStateBuilder.buildPlain<ScheduleTemplateTaskInfo>({
      snapshot,
      mode: this.mode,
      enabled: whenCreateOrEditMode(),
      children: {
        name: {
          required: true,
          enabled: includes([ScheduleTaskType.Empty, ScheduleTaskType.Summary], this.type)
            || (this.type === ScheduleTaskType.CostCenter && !this.fromCriticalPath),
        },
        duration: { enabled: false, type: NumberTypes.Days },
        costCenterCode: { enabled: false },
        description: void 0,
        resource: { enabled: false },
        changeDateAfterComplete: void 0,
        isExcludeFromGanttChart: void 0,
      },
    });
  }
}
